import { State } from "../types";

export type ClearMousePositionAction = Readonly<{
  type: "CLEAR MOUSE POSITION";
}>;

export const clearMousePosition = (state: State, _action: ClearMousePositionAction): State => {
  if (state.mouseDragStart === null && state.mousePosition === null) {
    return state;
  }
  return {
    ...state,
    mouseDragStart: null,
    mousePosition: null,
    withinGutter: null,
  };
};
